/** Reusable skeleton loading primitives */

export function Skeleton({ className = "" }) {
  return <div className={`bg-gray-200 animate-pulse rounded ${className}`} />;
}

export function MetricCardSkeleton() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-3 sm:p-5 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-3 sm:h-3.5 w-20 sm:w-24 rounded" />
          <Skeleton className="h-5 sm:h-7 w-12 sm:w-16 rounded" />
        </div>
        <Skeleton className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg shrink-0" />
      </div>
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-3 sm:p-5">
      <Skeleton className="h-4 w-40 rounded mb-4" />
      <Skeleton className="h-65 w-full rounded-lg" />
    </div>
  );
}

export function GrievanceCardSkeleton() {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col">
      <div className="p-5">
        {/* Badges */}
        <div className="flex items-center gap-1.5 mb-3">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-14 rounded-full" />
        </div>
        {/* Name + phone */}
        <Skeleton className="h-4 w-32 rounded mb-1.5" />
        <Skeleton className="h-3 w-20 rounded mb-3" />
        {/* Issue title */}
        <Skeleton className="h-3.5 w-full rounded mb-3" />
        {/* Location */}
        <Skeleton className="h-3 w-28 rounded mb-3" />
        {/* ID + timestamp */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-24 rounded" />
          <Skeleton className="h-3 w-28 rounded" />
        </div>
      </div>
      {/* Action buttons */}
      <div className="flex gap-2 px-5 pb-5 pt-0 mt-auto">
        <Skeleton className="flex-1 h-10 rounded-lg" />
        <Skeleton className="flex-1 h-10 rounded-lg" />
      </div>
    </div>
  );
}

export function UserCardSkeleton() {
  return (
    <div className="p-4 space-y-2">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-32 rounded" />
          <Skeleton className="h-3.5 w-24 rounded" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="h-4 w-8 rounded" />
          <Skeleton className="h-4 w-10 rounded" />
        </div>
      </div>
      <Skeleton className="h-3.5 w-44 rounded" />
      <div className="flex flex-wrap gap-1">
        <Skeleton className="h-5 w-16 rounded" />
        <Skeleton className="h-5 w-20 rounded" />
      </div>
    </div>
  );
}

export function UserTableRowSkeleton() {
  return (
    <tr>
      <td className="px-4 py-3"><Skeleton className="h-4 w-28 rounded" /></td>
      <td className="px-4 py-3"><Skeleton className="h-4 w-24 rounded" /></td>
      <td className="px-4 py-3"><Skeleton className="h-4 w-32 rounded" /></td>
      <td className="px-4 py-3">
        <div className="flex flex-wrap gap-1">
          <Skeleton className="h-5 w-16 rounded" />
          <Skeleton className="h-5 w-20 rounded" />
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="flex flex-wrap gap-1">
          <Skeleton className="h-5 w-14 rounded" />
          <Skeleton className="h-5 w-18 rounded" />
        </div>
      </td>
      <td className="px-4 py-3"><Skeleton className="h-4 w-20 rounded" /></td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-3">
          <Skeleton className="h-4 w-8 rounded" />
          <Skeleton className="h-4 w-10 rounded" />
        </div>
      </td>
    </tr>
  );
}
